import * as firebase from '@/firebase';
import moment from 'moment';

export default class CompaniesService {
  static async fetchCompanyInfo(companyId) {
    const profile = await firebase.companiesCollection.doc(companyId).get();

    return profile.data();
  }

  static async updateCompanyInfo(data) {
    const seconds = moment().unix();

    return firebase
      .companiesCollection
      .doc(data.companyId)
      .update({
        name: data.name,
        trading_name: data.tradingName,
        cnpj: data.cnpj,
        main_document: data.mainDocument,
        default_password: data.defaultPassword,
        updated_at: { seconds },
      });
  }
}
